import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { useRouter } from 'vue-router';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import './assets/styles.css';
import App from './App.vue';
import { router } from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);

// 全局 Plyr 实例缓存（供组件间通信）
const plyrInstances = new Map<HTMLVideoElement, Plyr>();
app.provide('plyrInstances', plyrInstances);

app.mount('#app');
